/**
 * Bug #452
 * @Author Santhosh Kumar
 * @Date 21 June 2021
 */
import axios from "axios";
import { API_PATIENT_SIGNIN,API_REFRESH_TOKEN } from 'api/endpoint';
import { detectMobileApp } from "shared/utils/detectDevice";
import { getPlatform } from "shared/utils/common-utils";
import local from 'store2';

export const signInUser = (data) => {
  return axios.post(API_PATIENT_SIGNIN, data);
};
/*** End ***/

/*Bug#755  @author Aby Joseph on 09 Feb 2022*/
export const getRefreshToken = (data) => {
  return axios.post(API_REFRESH_TOKEN, {refreshToken:data, platform: getPlatform(), deviceId: local.get("deviceId")});/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
};

export const resendExpiredAPICall = (oldRequest) => {
  if (oldRequest?.method === "post") {
    return axios.post(oldRequest?.url, oldRequest?.data ? oldRequest?.data instanceof FormData? oldRequest?.data : JSON.parse(oldRequest?.data) : {});
  }
  else {
    return axios.get(oldRequest?.url, {
      params: {
        ...oldRequest?.params
      },
    });
  }
}
/*** End ***/